import transferCall from './transferCall';

export default transferCall;
